import { render, staticRenderFns } from "./DepositsTableSorted.component.vue?vue&type=template&id=4c8845f4&scoped=true&"
import script from "./DepositsTableSorted.component.vue?vue&type=script&lang=js&"
export * from "./DepositsTableSorted.component.vue?vue&type=script&lang=js&"
import style0 from "./DepositsTableSorted.component.vue?vue&type=style&index=0&id=4c8845f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8845f4",
  null
  
)

export default component.exports